// const React = require("react")
import React from "react";

const AddWidgetPanel = ({ children, leftSidebar, rightSidebar }) => (
  <div className="add-widget-panel">
    <div
      className="inner"
      style={{
        marginLeft: leftSidebar ? "270px" : "0px",
        marginRight: rightSidebar ? "259px" : "0px"
      }}
    >
      {children}
    </div>
  </div>
);

AddWidgetPanel.displayName = "AddWidgetPanel";

// module.exports = AddWidgetPanel
export default AddWidgetPanel;
